import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Language} from '../../../../common/models/language';
import {AuthService} from '../../../../common/services/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {PersonType} from '../../../../common/enums/person-type.enum';
import {Principal} from '../../../../common/services/principal';
import {ModuleENUM} from '../../../../common/enums/module.enum';
import {NotificationService} from '../../services/notification.service';
import {Router} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {Utils} from '../../../../common/services/Utils';
import {WebSocketService} from '../../services/web-socket.service';
import {Menu} from './menu';
import {SubMenu} from './sub-menu';
import {ModuleExtendedAccessIdEnum} from '../../../../common/enums/module-extended-access-id.enum';
import {ModuleExtendedEdit} from '../../../../common/enums/module-extended-edit.enum';
import {EsuvoOptionService} from 'app/modules/shared/services/esuvo-option.service';

declare const $: any;
declare const initPcodedComp: any;
declare const initPcodedSearchTopPnls: any;

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonLayoutComponent implements OnInit, OnDestroy {

  languages = [];
  currentLanguage: Language;
  logoPemPath = 'assets/images/pem_logo.png';
  logoEsuorPath = 'assets/images/esuor_logo.png';
  avatarPath = 'assets/images/avatar.png';
  mainMenuList = [];
  notificationList = [];
  notificationCount;
  user: any;
  isAdmin = false;
  isRegionAdmin = false;
  isModerator = false;
  isUser = false;
  isEnroll = false;
  isParameterAuthorize: any;
  isUniversityWorker = false;
  childCommand: any;
  wsUserDest = null;
  showMenuIcon = true;

  constructor(private _authService: AuthService,
              public _principal: Principal,
              private _router: Router,
              private _commonService: CommonService,
              private _esuvoOptionService: EsuvoOptionService,
              private _notificationService: NotificationService,
              private _utils: Utils,
              private  _socketService: WebSocketService,
              private _translateService: TranslateService) {
    this._principal.reloadUserData();
  }

  ngOnInit() {
    this.languages = Language.languages;
    this.currentLanguage = Language.getCurrentLanguage();
    this.user = this._principal.getUser();
    this.isUniversityWorker = this._principal.getUserCollegeId() > 0;
    this.isAdmin = this._principal.isAdmin();
    this.isRegionAdmin = this._principal.isRegionAdmin();
    this.isModerator = this._principal.isModerator();
    this.isUser = this._principal.isUser();
    this.isEnroll = this._principal.isEnroll();
    this.isParameterAuthorize = this._principal.getAccessByModuleId('AUTHORIZATION_PARAMS');
    this.initializeMainMenu();
    this.loadNotifications();
    this.initProfilePhoto();
    this.childCommand = this._commonService.getChildCommand().subscribe(data => {
      if (data.cmd == 'RELOAD_PROFILE_PHOTO') {
        this.initProfilePhoto(data.params);
      } else if (data.cmd == 'MAIL_INBOX_COUNT') {
        this.changeInboxMessageCount();
      }
    });
    this.isUserGeneratedOneTimePassword();
    this.wsUserDest = '/topic/user/' + this._principal.getUserId();
    this._socketService.subscribe(this.wsUserDest, (frame) => {
      if (frame) {
        // console.log('subscribe frame', frame);
        if (frame.type == 'NOTIFICATION') {
          this.loadNotifications();
          const opt = {
            message: 'Новое уведомление "' + frame.data.messageRu + '"',
            acceptMessage: 'Перейти',
            declineMessage: 'Close'
          };

          this._utils.confirmDialog(opt, ok => {
            // this._notificationService.updateUserStatus(frame.data.notificationId, frame.data.userId).subscribe(() => {
            //   this._notificationService.goToPage(frame.data, this._router);
            // });
            this._router.navigate(['user/notification-list'], {queryParams: {'status': 'UNREAD'}});
          });
          // this._utils.notifyInfo(frame.data.messageRu, null);
          // this._router.navigate([]);
        }
      }
    });
  }


  isUserGeneratedOneTimePassword() {
    if (this.user.passwordOneTimeGenerated) {
      const elMenu: HTMLElement = document.getElementById('mobile-collapse') as HTMLElement;
      elMenu.click();
      elMenu.style.display = 'none';
    }
  }

  initializeMainMenu() {
    initPcodedComp();
    initPcodedSearchTopPnls();
    if (this.isAdmin || this.isRegionAdmin) {
      // this.mainMenuList.push({route: 'web-config', menuText: 'web_server_configuration', icon: 'ti-settings'});
      this.mainMenuList.push({
        route: null, menuText: 'public_page', icon: 'ti-receipt', cssClass: 'pcoded-hasmenu',
        subMenuList: [
          {icon: '', menuText: 'public_page_menu', route: 'cmn/public-page-menu'},
          {icon: '', menuText: 'Moderators', route: 'cmn/moderators'},
          // {icon: '', menuText: 'tech_support.title', route: 'cmn/tech-support'},
          {icon: '', menuText: 'Footer', route: 'cmn/footer-edit'}]
      });
      this.mainMenuList.push({route: 'mail-service-settings', menuText: 'email_service', icon: 'ti-email'});
      this.mainMenuList.push({route: 'authorization-options', menuText: 'authorization_settings', icon: 'ti-key'});
      this.mainMenuList.push({route: 'events', menuText: 'Events', icon: 'ti-pencil-alt'});
      this.mainMenuList.push({route: 'authorization-parameter', menuText: 'authorization_params', icon: 'ti-id-badge'});
      this.mainMenuList.push({route: 'administering-roles', menuText: 'administering_roles', icon: 'ti-user'});
      this.mainMenuList.push({route: 'dictionary', menuText: 'dictionaries', icon: 'ti-id-badge'});
      this.mainMenuList.push({route: 'other-settings', menuText: 'other_settings.title', icon: 'ti-id-badge'});

    } else if (this.isUser) {

      if (this._principal.getAccessByModuleId(ModuleENUM.MESSAGES)) {
        this.mainMenuList.push({route: 'mail', menuText: 'mail.title', icon: 'ti-email'});
        this.changeInboxMessageCount();
      }
      const data = [];
      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_GRADUATES)) {
        data.push({route: 'data/graduates', menuText: 'graduates', icon: ''});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_STUDENTS)) {
        data.push({route: 'data/students', menuText: 'cur_students', icon: ''});
      }

      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_APPLICANTS)) {
        data.push({route: 'data/applicants', menuText: 'enrolle', icon: ''});
      }

      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_TUTORS)) {
        data.push({route: 'data/tutors', menuText: 'tutors', icon: ''});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_REPLICATIONS)) {
        data.push({route: 'data/center-replic-node', menuText: 'center_replic_node.name', icon: ''});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.DATA_COLLEGE_INFO)) {
        data.push({route: 'data/colleges', menuText: 'college_info.college', icon: ''});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.DORMITORY_INFO)) {
        data.push({route: 'data/dormitories-list', menuText: 'college_info.dormitory', icon: ''});
      }
      if (data.length) {
        this.mainMenuList.push({
          route: null, menuText: 'data', icon: 'fa fa-database', cssClass: 'pcoded-hasmenu',
          subMenuList: data
        });
      }
      const goz = [];
      if (this._principal.getAccessByModuleId(ModuleENUM.GRANTS)) {
        goz.push({route: 'grant/finance020-contingent', menuText: 'grants.former_sample'});
        goz.push({route: 'grant/service-expenses-students', menuText: 'grants.service_expenses_students'});
        goz.push({route: 'grant/service-expenses-students-addition', menuText: 'grants.service_expenses_students_addition'});
        goz.push({route: 'grant/scholarship-expenses', menuText: 'grants.scholarship_expenses'});
        if (this._principal.hasModuleExtendedEdit(ModuleENUM.GRANTS, ModuleExtendedEdit.GRANT_REPORT_PERIOD)
          || this._principal.hasModuleExtendedEdit(ModuleENUM.GRANTS, ModuleExtendedEdit.RECALCULATE_CONTINGENT)
          || this._principal.hasModuleExtendedEdit(ModuleENUM.GRANTS, ModuleExtendedEdit.SET_RECALCULATE_DAY)) {
          goz.push({route: 'grant/settings', menuText: 'Settings'});
        }
      }
      if (goz.length) {
        this.mainMenuList.push({
          route: null, menuText: 'grants.title', icon: 'ti-receipt', cssClass: 'pcoded-hasmenu',
          subMenuList: goz
        });
      }

      if (this._principal.getAccessByModuleId(ModuleENUM.LOCAL_ROLE_EDIT)) {
        this.mainMenuList.push({route: 'local-role', menuText: 'local_role.title', icon: 'ti-key'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.USERS)) {
        this.mainMenuList.push({route: 'user-information', menuText: 'users', icon: 'fa fa-user'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.USER_APPLICATIONS)) {
        this.mainMenuList.push({route: 'user-application', menuText: 'user_application.processing_short', icon: 'fa fa-user-plus'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.PUBLIC_SERVICES)) {
        const menu = new Menu('ps', 'ps.title', 'ti-id-badge', 'pcoded-hasmenu');
        menu.subMenuList.push(new SubMenu('ps/gov-services/individuals', 'ps.individuals', '', ''));
        /*menu.subMenuList.push(new SubMenu('ps/gov-services/legal-entities', 'ps.legal_entities', '', ''));*/
        this.mainMenuList.push(menu);
        /*const extAccessIds = this
          ._principal
          .getExtAccessByModuleCodeAndAccessCode(ModuleENUM.PUBLIC_SERVICES, ModuleExtendedAccessIdEnum[9]);
        const menu = new Menu('ps', 'ps.title', 'ti-id-badge', 'pcoded-hasmenu');
        if (extAccessIds && extAccessIds.length) {
          for (let i = 0; i < extAccessIds.length; i++) {
            if (extAccessIds[i] === 4) {
              menu.subMenuList.push(new SubMenu('ps/diploma-duplicate', 'ps.diploma_duplicate.title', '', ''));
            } else if (extAccessIds[i] === 5) {
              menu.subMenuList.push(new SubMenu('ps/academic-mobility', 'ps.academic_mobility.title', '', ''));
            } else if (extAccessIds[i] === 1) {
              menu.subMenuList.push(new SubMenu('ps/hostel', 'ps.hostel.title', '', ''));
            }
          }
        } else {
          menu.subMenuList.push(new SubMenu('ps/diploma-duplicate', 'ps.diploma_duplicate.title', '', ''));
          menu.subMenuList.push(new SubMenu('ps/academic-mobility', 'ps.academic_mobility.title', '', ''));
          menu.subMenuList.push(new SubMenu('ps/hostel', 'ps.hostel.title', '', ''));
          menu.subMenuList.push(new SubMenu('ps/academic-leave', 'ps.academic_leave.title', '', ''));
        }
        menu.subMenuList.push(new SubMenu('ps/education-not-finished', 'ps.info_education_not_finished.title', '', ''));
        if (!this.user.collegeId) {
          menu.subMenuList.push(new SubMenu('ps/settings', 'ps.settings.title', '', ''));
        }*/

      }

      this._esuvoOptionService.getOptionDto('RECEIVE_ENROLL_ON_ESUOR_BASE').subscribe(data => {
        if (!!(this._principal.getAccessByModuleId(ModuleENUM.ENROLLE)) && data.booleanValue) {
          this.mainMenuList.push({
            route: null, menuText: 'register.application_process', icon: 'ti-id-badge', cssClass: 'pcoded-hasmenu',
            subMenuList: [{route: 'requests/enrolle', menuText: 'enrolle', icon: ''}]
          });
        }
      });

      const menuApplicationProcess = [];
      if (this._principal.getAccessByModuleId(ModuleENUM.REGISTER_GRADUATES_PROCESS)) {
        menuApplicationProcess.push({icon: '', menuText: 'register.application_process', route: 'register/graduate-list'});
      }
      if (menuApplicationProcess.length) {
        this.mainMenuList.push({
          route: 'register', menuText: 'index_page_route.REGISTER_GRADUATE', icon: 'ti-id-badge', cssClass: 'pcoded-hasmenu',
          subMenuList: menuApplicationProcess
        });
      }

      if (this._principal.getAccessByModuleId(ModuleENUM.GPRON)) {
        this.mainMenuList.push({route: 'gpro-list', menuText: 'gpro.title', icon: 'ti-receipt'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.REPORT_EDITOR)) {
        this.mainMenuList.push({route: 'report-editor', menuText: 'report_editor.title', icon: 'ti-view-list-alt'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.REP_SUBMISSIONS)) {
        this.mainMenuList.push({
          route: null, menuText: 'rep.title_short', icon: 'ti-list', cssClass: 'pcoded-hasmenu',
          subMenuList: [
            {icon: '', menuText: 'rep.submissions.title', route: 'rep/submissions'}]
        });
      }
      if (this.user.collegeId && this._principal.getAccessByModuleId(ModuleENUM.FORM_APPLICATION)) {
        this.mainMenuList.push({route: 'form-applications', menuText: 'form_application.request.title', icon: 'ti-receipt'});
      }
      if (!this.user.collegeId && this._principal.getAccessByModuleId(ModuleENUM.FORM_APPLICATION_PROCESS)) {
        this.mainMenuList.push({route: 'form-applications-process', menuText: 'form_application.process.title', icon: 'ti-receipt'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.DICTIONARY)) {
        this.mainMenuList.push({route: 'dictionary', menuText: 'dictionaries', icon: 'ti-book'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.REPORTS)) {
        this.mainMenuList.push({route: 'reports', menuText: 'report.reports', icon: 'fa fa-bar-chart'});
        this.initUserReportCategoryMenu();
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.PLATONUS_RELEASE)) {
        this.mainMenuList.push({route: 'releases-info', menuText: 'Обновления', icon: 'fa fa-registered'});
      }
      if (this._principal.getAccessByModuleId(ModuleENUM.COLLEGE_CAPACITY)) {
        this.mainMenuList.push({route: 'ps/gov-services/legal-entities', menuText: 'Проектная мощность', icon: 'fa fa-registered'});
      }

    } else if (this.isModerator) {
      this.mainMenuList.push({
        route: null, menuText: 'public_page', icon: 'ti-receipt', cssClass: 'pcoded-hasmenu',
        subMenuList: [
          {icon: '', menuText: 'public_page_menu', route: 'cmn/public-page-menu'},
          {icon: '', menuText: 'tech_support.title', route: 'cmn/tech-support'},
          {icon: '', menuText: 'Footer', route: 'cmn/footer-edit'}]
      });
      this.mainMenuList.push({route: 'authorization-parameter', menuText: 'authorization_params', icon: 'ti-id-badge'});

    } else if (this.isEnroll) {
      this.mainMenuList.push({route: 'cabinet', menuText: 'enroll_cabinet', icon: 'ti-cabinet'});
    }
  }

  changeLanguage(languageCode): void {
    localStorage.setItem(Language.SYSTEM_LANGUAGE_CODE_LABEL, languageCode);
    this._translateService.setDefaultLang(languageCode);
    this._translateService.use(languageCode);
    this.currentLanguage = Language.getLangObject(languageCode);
    this.notificationList = this._utils.translateListWithSort(this.notificationList, 'message');
  }

  loadNotifications() {
    const page = {size: 10, pageNumber: 0, filter: {status: 'UNREAD'}};
    this._notificationService.getListByUser(page).subscribe(data => {
      this.notificationList = this._utils.translateListWithSort(data.dtoList, 'message');
      this.notificationCount = data.totalElements;
    });
  }

  initUserReportCategoryMenu() {
    this._commonService.getUserReportCategoryList().subscribe(data => {
      if (data && data.length) {
        data.forEach(e => {
          this.mainMenuList.push({route: 'category-reports/' + e.id, menuText: e.nameRu, icon: ''});
        });
      }
    });
  }

  goToNotificationPage(item) {
    const isSame = this._principal.getUserId() === item.userId && item.userId > 0;
    if (item.status === 'UNREAD' && isSame) {
      this._notificationService.updateUserStatus(item.notificationId, item.userId).subscribe(() => {
        this.loadNotifications();
        this._notificationService.goToPage(item, this._router);
      });
    } else {
      this._notificationService.goToPage(item, this._router);
    }
  }

  initProfilePhoto(params?: any) {
    if (params) {
      this.user.profilePhoto = params.photo;
    }

    if (!this.user.profilePhoto) {
      this.user.profilePhoto = this.avatarPath;
    }
  }

  changeInboxMessageCount() {
    if (this._principal.getAccessByModuleId(ModuleENUM.MESSAGES)) {
      this._commonService.getInboxNewCount().subscribe(count => {
        if (count) {
          count = ' (' + count + ')';
        } else {
          count = '';
        }
        const mail = this.mainMenuList.find(e => e.route == 'mail');
        if (mail) {
          mail.menuText = this._utils._translateService.instant('mail.title') + count;
        }
      });
    }
  }

  onLogout() {
    this._authService.logout(PersonType.USER);
  }

  ngOnDestroy(): void {
    this._socketService.unsubscribe(this.wsUserDest);
    if (this.childCommand) {
      this.childCommand.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/common-layout/common.component.ts